import { render, staticRenderFns } from "./CompanyEmployeeLeaveAssignmentModal.vue?vue&type=template&id=d6fdece6&scoped=true&"
import script from "./CompanyEmployeeLeaveAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./CompanyEmployeeLeaveAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fdece6",
  null
  
)

export default component.exports